export interface AssignorOption {
  name: string
  address: string
}

export interface AssignorProfile extends AssignorOption {
  accountType: string
}

/** Settings used to be a string[]. Rows are now a name plus the address that fills Assignor Address. */
export function normalizeAssignorOptions(value: unknown): AssignorOption[] {
  if (!Array.isArray(value)) return []
  return value
    .map((item) => {
      if (typeof item === 'string') return { name: item.trim(), address: '' }
      if (item && typeof item === 'object') {
        const row = item as { name?: unknown; address?: unknown }
        return {
          name: String(row.name || '').trim(),
          address: String(row.address || '')
            .replace(/\s+/g, ' ')
            .trim(),
        }
      }
      return { name: '', address: '' }
    })
    .filter((item) => item.name)
}

export function addressForAssignor(options: AssignorOption[], name: string) {
  if (!name) return ''
  return options.find((item) => item.name === name)?.address || ''
}
